var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67776 21C8.74114 21 7.89738 20.7885 7.14647 20.3655C6.39556 19.9425 5.79806 19.3545 5.35397 18.6015C4.91796 17.857 4.69995 16.9898 4.69995 16C4.69995 15.0102 4.91796 14.143 5.35397 13.3985C5.79806 12.6455 6.39556 12.0575 7.14647 11.6345C7.89738 11.2115 8.74114 11 9.67776 11H22.3221C23.2588 11 24.0985 11.2115 24.8413 11.6345C25.5922 12.0575 26.1897 12.6455 26.6338 13.3985C27.0779 14.143 27.3 15.0102 27.3 16C27.3 16.9898 27.0779 17.857 26.6338 18.6015C26.1897 19.3545 25.5922 19.9425 24.8413 20.3655C24.0985 20.7885 23.2588 21 22.3221 21H9.67776ZM22.637 19.4898C23.2426 19.4898 23.7957 19.3333 24.2963 19.0203C24.7969 18.7073 25.1966 18.2843 25.4953 17.7513C25.7941 17.2183 25.9475 16.6303 25.9556 15.9873C25.9556 15.3528 25.8062 14.7775 25.5075 14.2614C25.2087 13.7369 24.809 13.3181 24.3084 13.0051C23.8078 12.692 23.2507 12.5355 22.637 12.5355C22.0234 12.5355 21.4663 12.692 20.9657 13.0051C20.465 13.3181 20.0654 13.7369 19.7666 14.2614C19.4759 14.786 19.3306 15.3655 19.3306 16C19.3306 16.643 19.4759 17.2267 19.7666 17.7513C20.0573 18.2758 20.4529 18.6946 20.9535 19.0076C21.4622 19.3206 22.0234 19.4814 22.637 19.4898Z",
    fill: "#11B35C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSwitch);
export default __webpack_public_path__ + "static/media/activeSwitch.e180c3c53f16cc8f4501139554f4eaed.svg";
export { ForwardRef as ReactComponent };